import {
  emptyChecklistItemHelper,
  hideSidebarInMobile,
} from '@/utils';
import { titles } from '@/services/checks/product.checks';

const TRANSITION_DELAY = 800;

const resourceClick = (
  context: any,
  resource: string,
) => {
  // clicks resource add button
  const { $el } = context.$refs[resource];
  $el.scrollIntoView(true);
  hideSidebarInMobile(context);

  if (!context.data[resource].length) {
    $el.querySelector('button:not([class*=ShowGuide])').click();
  }
};

export default (context: any) => ({
  [titles.COMPONENTS]: () => resourceClick(context, 'components'),
  [titles.IMAGERY]() {
    context.selectPanel('assets');
    setTimeout(() => {
      context
        .$refs
        .assetManager
        .$el
        .querySelector('.asset-manager-add')
        .click();
    }, TRANSITION_DELAY);
  },
  [titles.MATERIALS]: () => resourceClick(context, 'materials'),
  [titles.PRICING]: () => emptyChecklistItemHelper(context, 'prices'),
  [titles.PROPERTIES]: () => emptyChecklistItemHelper(context, 'properties'),
  [titles.NAME]() {
    // focus on field
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-name input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.SIZES]() {
    const element = context.$refs.sizes.$el;
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    setTimeout(() => {
      element.querySelector('button:not([class*=ShowGuide])').click();
      context.$nextTick(() => {
        const firstSizeCategoy = '[class*="GridRow_row_"]:nth-child(2) input';
        element.querySelector(firstSizeCategoy).focus();
      });
    }, 1000);
    hideSidebarInMobile(context);
  },
  [titles.WASHING]() {
    context.selectPanel('washing');
  },
});
